import { Component, OnInit, AfterViewInit, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentSlideService } from '../_services/current-slide.service';
import { SectionsService } from '../_services/sections.service';
import { PreviousRouteService } from '../_services/previous-route.service';
import { AppConstants } from '../app.constants';
import { LoadingService } from '../_services/loading.service';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var ScrollMagic: any;
declare var TweenMax: any;
declare var Linear: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    private unsubscribe$ = new Subject<void>();
    currentSectionId: number;
    public sections;
    public timeoutAutoGoSection = null;
    public isTimeoutAutoOn: boolean = true;
    public sectionsContent = [];

    isLoaded: boolean = false;
    isFirstLoadTest: boolean = true;
    percent: number = 0;

    scenePop1: any;
    scenePop2: any;

    constructor(
        private _router: Router,
        private _elRef: ElementRef,
        private _sectionsService: SectionsService,
        private _previousRouteService: PreviousRouteService,
        private _loading: LoadingService,
        private _currentSlideService: CurrentSlideService) {
        this.currentSectionId = this._sectionsService.getCurrentSectionPosition();
        this.sectionsContent = AppConstants.sectionEmpty;
        this.sections = this._sectionsService.getSections();
        this._currentSlideService.setAutoplay(false);


    }

    ngOnInit() {

        this._loading.isLoaded
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => {
                if (data == true) {
                    this.isLoaded = true;
                }
                else {
                    this.isFirstLoadTest = false;
                    setTimeout(() => {
                        this.preloadImages();
                    }, 500)
                }
            });

        this._sectionsService.setCurrentSectionContent(this.sectionsContent);
        let prevUrl = this._previousRouteService.getPreviousUrl().split('/');
        if (prevUrl[2] == 'story') {
            this.goToSection(this._sectionsService.getCurrentSectionPosition(), true);
            this.getSectionsContent(this._sectionsService.getCurrentSectionPosition());
            setTimeout(() => {
                this.goToSection(this._sectionsService.getCurrentSectionPosition(), false);
            }, 200)
        }
        this._sectionsService.changeSection
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(position => {
                this.currentSectionId = this._sectionsService.getCurrentSectionPosition();
                this.getSectionsContent(this.currentSectionId)
                this.goToSection(this.currentSectionId, false);
            });


    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.initSceneParallaxHeight();
        this.goToSection(this.currentSectionId, false, 0);
        
    }



    ngAfterViewInit() {

        var controllerHome = new ScrollMagic.Controller({ container: ".sgc-page" });
        let sectionsHeight = this.getSectionsParallaxHeight();
        this.autoGoStory();

        this._currentSlideService.changeAutoLoopHome
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => {
                this.isTimeoutAutoOn = data;
                if (!this.isTimeoutAutoOn) {
                    //stop autoplay
                    this.stopAutoGoStory(false);
                }
                else {
                    //start autoplay
                    this.autoGoStory();
                }
            });

        //var watchL1 = TweenMax.to("#test", 1, {x: '100%', y: '500%', ease: Linear.easeInOut});

        //SPACE
        new ScrollMagic.Scene({ triggerElement: "#space", duration: '300%' })
            .setTween("#moon", { y: '-35%', ease: Linear.easeInOut })
            //.addIndicators()
            .addTo(controllerHome);
        new ScrollMagic.Scene({ triggerElement: "#space", duration: '300%' })
            //.setTween(watchL1)
            .setTween("#satellite", { x: '100%', y: '500%', ease: Linear.easeInOut })
            //.setPin("#test")
            //.addIndicators()
            .addTo(controllerHome);

        //POP CULTURE
		/*new ScrollMagic.Scene({triggerElement: "#pop-culture", duration: '300%'})
			.setTween("#pilot", {y: '50%', ease: Linear.easeInOut})
			//.addIndicators()
			.addTo(controllerHome);*/

        this.scenePop1 = new ScrollMagic.Scene({ triggerElement: "#pop-culture", duration: sectionsHeight[0], triggerHook: "onCenter" })
            .setTween("#pop-culture-2 .pop-culture-img", { y: '-5%', ease: Linear.easeInOut })
            //.addIndicators()
            .addTo(controllerHome);

        this.scenePop2 = new ScrollMagic.Scene({ triggerElement: "#pop-culture", duration: sectionsHeight[0], triggerHook: "onCenter" })
            .setTween("#pop-culture-3 .pop-culture-img", { y: '-15%', ease: Linear.easeInOut })
            //.addIndicators()
            .addTo(controllerHome);



        //CITY
        new ScrollMagic.Scene({ triggerElement: "#city", duration: '300%' })
            .setTween("#city-5", { y: '-35%', ease: Linear.easeInOut })
            //.addIndicators()
            .addTo(controllerHome);
        new ScrollMagic.Scene({ triggerElement: "#city", duration: '300%' })
            .setTween("#city-4", { y: '-20%', ease: Linear.easeInOut })
            //.addIndicators()
            .addTo(controllerHome);
        new ScrollMagic.Scene({ triggerElement: "#city", duration: '300%' })
            .setTween("#city-3", { y: '-5%', ease: Linear.easeInOut })
            //.addIndicators()
            .addTo(controllerHome);


        //SEA
		/*new ScrollMagic.Scene({triggerElement: "#sea", duration: '200%' })
			.setTween("#diver", {y: '50%', ease: Linear.easeInOut})
			.addTo(controllerHome);
		new ScrollMagic.Scene({triggerElement: "#sea", duration: '200%' })
			.setTween("#dolphins", {y: '-70%', ease: Linear.easeInOut})
			.addTo(controllerHome);*/

        //ACCUTRON
        new ScrollMagic.Scene({ triggerElement: "#sea", duration: '100%' })
            .setTween("#bg-accutron", { y: '5%', ease: Linear.easeInOut })
            .addTo(controllerHome);

    }

    getSectionsParallaxHeight() {
        let wrap = this._elRef.nativeElement;
        let scene1H = wrap.querySelector('#pop-culture').offsetHeight;
        return [scene1H];
    }
    initSceneParallaxHeight() {
        let scenesHeight = this.getSectionsParallaxHeight();
        this.scenePop1['duration'](scenesHeight[0]);
        this.scenePop2['duration'](scenesHeight[0]);
    }

    goToSection(pos, story: boolean, duration:number = 3000) {
        let windowH = $(window).height();
        let page = $('.js-home-section-scroll');
        let pageH = page.height();
        let el = $('.home-section-' + pos + ' .home-section__content');
        let newPosition;
        this.stopAutoGoStory(true);
        if (!el.length) {
            let newPosition = windowH * this.sectionPositionBack(pos);
            $(".sgc-page").scrollTop(newPosition);
        }
        else {
            if (story) {
                //let newPosition = windowH * pos * 4;
                let newPosition = windowH * this.sectionPositionBack(pos);
                $(".sgc-page").scrollTop(newPosition);
            }
            else {
                let newPosition = el.offset().top - page.offset().top;
                $(".sgc-page").stop().animate({
                    scrollTop: newPosition
                }, duration);
            }
        }
    }

    getSectionsContent(sectionId) {
        switch (sectionId) {
            case 0:
                this.sectionsContent = AppConstants.sectionExploration;
                this._sectionsService.setCurrentSectionContent(this.sectionsContent);
                break;
            case 1:
                this.sectionsContent = AppConstants.sectionInnovation;
                this._sectionsService.setCurrentSectionContent(this.sectionsContent);
                break;
            case 2:
                this.sectionsContent = AppConstants.sectionCity;
                this._sectionsService.setCurrentSectionContent(this.sectionsContent);
                break;
            case 3:
                this.sectionsContent = AppConstants.sectionPopCulture;
                this._sectionsService.setCurrentSectionContent(this.sectionsContent);
                break;
            default:
                this.sectionsContent = AppConstants.sectionExploration;
                this._sectionsService.setCurrentSectionContent(this.sectionsContent);



        }
    }

    sectionPositionBack(pos) {
        let newPos = 0;
        switch (pos) {
            case 0:
                newPos = 0;
                break;
            case 1:
                newPos = 3;
                break;
            case 2:
                newPos = 7.05;
                break;
            case 3:
                newPos = 10;
                break;
            default:
                newPos = 0
        }
        return newPos;
    }


    autoGoStory() {
		/*this.timeoutAutoGoSection = setTimeout(() => {
			this._router.navigate([this.sections[this.currentSectionId].routeName+'/story']);	
		}, 10000);*/
    }
    stopAutoGoStory(restart) {
        clearTimeout(this.timeoutAutoGoSection);
        if (restart) {
            this.autoGoStory()
        }
    }

    preloadImages() {
        var base = this;
        var images = new Array()
        let imgArray = this.pageImages();

        this._loading.loadImages(imgArray);



        setTimeout(() => {
			/*this._loading.loadedImage
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(data => {
				if(data.loaded == data.total){
					this.initSceneParallaxHeight();
				}
			});*/

            this._loading.loadedImage
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(data => {
                    //console.log(data);
                    this.percent = data.percent;
                    //console.log(this.percent)
                    if (data.total > 0 && data.loaded == data.total) {
                        setTimeout(() => {
                            this.initSceneParallaxHeight();
                            base.isLoaded = true;
                            this._loading.setIsLoaded(true);
                        }, 500)
                    }
                });
        }, 100)
    }

    pageImages() {
        let page = this._elRef.nativeElement;
        var imgs = page.querySelectorAll("img");
        //var imgSrcs = [];
        var imgSrcs = [
            "assets/images/home/moon.jpg",
            "assets/images/home/city2.png",
            "assets/images/home/city3.png",
            "assets/images/home/city4.png",
            "assets/images/home/city5.png",
            "assets/images/home/home-city-sky.jpg",
            "assets/images/home/home-pop-culture.jpg",
            "assets/images/home/pop-culture-1.png",
            "assets/images/home/pop-culture-2.png",
            "assets/images/home/home-accutron.jpg"
        ];
        var imgSrcsMob = [
            "assets/images/home/moon-mobile.jpg",
            "assets/images/home/city2-mobile.png",
            "assets/images/home/city3-mobile.png",
            "assets/images/home/city5-mobile.png",
            "assets/images/home/home-city-sky-mobile.jpg",
            "assets/images/home/home-pop-culture-mobile.jpg",
            "assets/images/home/pop-culture-1-mobile.png",
            "assets/images/home/pop-culture-2-mobile.png",
            "assets/images/home/home-accutron-mobile.jpg"
        ];



		/*for (var i = 0; i < imgs.length; i++) {
			if(imgs[i].currentSrc == ""){
				imgSrcs.push(imgs[i].src);
				console.log(imgs[i].currentSrc)
			}
			else{
				imgSrcs.push(imgs[i].currentSrc);
			}
		}
		console.log(imgSrcs)*/
        if (window.innerWidth < 1000) {
            return imgSrcsMob;
        }
        else {
            return imgSrcs;
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}



